/**
 * Fetches the logged-in contractor's AI training profile once on mount.
 * Returns null for unauthenticated / offline users, which is the signal
 * the QuoteConfidence widget uses to stay hidden.
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useTrainingProfile = () => {
  const [training, setTraining] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/ai/training-profile`, { withCredentials: true });
        if (!cancelled) setTraining(data);
      } catch {
        // Unauthenticated marketing-page user — confidence card stays hidden.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return training;
};
